import SlideToggle from "./modules/_slide-toggle";
import SmoothScroll from './modules/_smooth-scroll'
import VideoModal from './modules/_video-modal'
import NewsletterForm from './modules/_newsletter-form'

document.addEventListener('DOMContentLoaded', () => {
  SlideToggle()
  SmoothScroll()
  VideoModal()
  NewsletterForm()
})
